module.exports = __webpack_public_path__ + "img/number-2.3399e722.svg";